import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { Tab, Form, Input, Button } from '@alifd/next';
import styles from '../../../index.module.scss';
import LzTag from '@/components/common/LzTag';
import LzDialog from '@/components/common/LzDialog';
import LzMsg from '@/components/common/LzMsg';
import SaveCrowd from '@/components/canvas/Nodes/saveCrowd';
import { CanvasService } from '@/service';

// tab选项卡
const panes = [
  {
    tab: '详情',
    key: '0'
  },
  {
    tab: '任务',
    key: '1'
  }
];

export default ({activityInfo = {}, initData = {}, runState = {}, changeData = (data) => {}, onCancel = () => {}}) => {
  // 控制保存人群包弹窗的变量
  const [ isSelectCrow, setSelectCrow ] = useState(false);
  // 保存人群包所需数据
  const [ saveCrowdData, setCrowdData ] = useState({
    name: '',
    remark: '',
    resultNumber: '',
    strategyInstId: ''
  })
  // Tab展示 0：详情，1：任务
  const [showTabkey, setShowTabkey] = useState('0');
  // 组件内部的数据 原表单数据
  const [data, setData] = useState({
    ...initData
  });
  // 节点运行时详情数据
  const [state, setState] = useState({
    ...runState
  });

  /**
   * 点击确认，保存人群
   */
  const confirm = (crowdInfo) => {
    let param = {
      ...crowdInfo
    }
    param.resultNumber = state.variables[0].resultNum;
    param.strategyInstId = state.variables[0].searchId;
    CanvasService.saveNewCrowd(param).then(res => {
      setSelectCrow(false);
      LzMsg.success('保存成功');
    }).catch(e => {
      console.log(e)
    })
  };

  /**
   * 点击退出保存人群弹窗
   */
  const cancel = () => {
    setSelectCrow(false);
  };

  return (
    <div className={`page-Padding ${styles.detailRoot} canvasDetailDialog`} style={{padding: '30px'}}>
      <div className="second-level">
        <Tab shape="wrapped" onChange = {setShowTabkey}>
          {
            panes.map(pane => <Tab.Item title={pane.tab} key={pane.key} className="justify-tabs-tab"/>)
          }
        </Tab>
      </div>
      {
        showTabkey === '0' && <Form className={`${styles.formDiv} canvasDialog`}>
          <Form.Item label="节点ID:">
            <div className={`formItemWidth ${styles.lineHeightNormal}`}>{state.nodeId ? state.nodeId : '--'}</div>
          </Form.Item>
          <Form.Item label="节点名称:">
            <div className={`formItemWidth ${styles.lineHeightNormal}`}>{data.name}</div>
          </Form.Item>
          {
            activityInfo.executionPlan.type === 1 && <Form.Item label="执行时间:">
              <>
                {
                  data.cycleType === 1 && <div className={`formItemWidth ${styles.lineHeightNormal}`}>{moment(data.executionTime).format('YYYY-MM-DD')}</div>
                }
                {/* {
                  data.cycleType === 2 && <div className={`formItemWidth ${styles.lineHeightNormal}`}>延迟{(data.executionTime - data.executionMinute * 60000)/3600000}小时{data.executionMinute}分钟</div>
                } */}
              </>
            </Form.Item>
          }
          <Form.Item label="选择人群:">
            <div>
              {/* <div className={`formItemWidth ${styles.lineHeightNormal}`}>{state.variables && state.variables[0] ? state.variables[0].searchName : '--'}</div> */}
              <div className={`formItemWidth ${styles.lineHeightNormal}`}>{data.crowdName}</div>
              <div className={`formItemWidth ${styles.crowdList} ${styles.displayFlex} ${styles.crowdNumber}`}>
                <span>人群数量: {state.variables && state.variables[0] ? state.variables[0].resultNum : '--'}人</span>
                {/* {
                  state.variables && state.variables[0] && <span className={styles.globalLink} onClick={() => {setCrowdData({...saveCrowdData,resultNumber: state.variables[0].resultNum}),setSelectCrow(true)}}>保存人群包</span>
                } */}
              </div>
            </div>
          </Form.Item>
          <Form.Item label="备注:">
            <div className={`formItemWidth canvas-node-remark ${styles.lineHeightNormal}`}>{data.remark}</div>
          </Form.Item>
        </Form>
      }
      {
        showTabkey === '1' && <Form className={`${styles.formDiv} canvasDialog`}>
          <Form.Item label="任务ID:">
            <div className={`formItemWidth ${styles.lineHeightNormal}`}>{state.activityInfo && state.activityInfo.jobId ? state.activityInfo.jobId : '--'}</div>
          </Form.Item>
          <Form.Item label="任务执行周期:">
            <div className={`formItemWidth ${styles.lineHeightNormal}`}>{(state.activityInfo && state.activityInfo.startTime) ? `${moment(state.activityInfo.startTime).format('YYYY-MM-DD HH:mm:ss')} 至 ` : '--'}{(state.activityInfo && state.activityInfo.endTime && state.activityInfo.endTime !== -1) ? moment(state.activityInfo.endTime).format('YYYY-MM-DD HH:mm:ss') : ''}</div>
          </Form.Item>
          <Form.Item label="状态:">
            <div className={`formItemWidth ${styles.lineHeightNormal}`}>
              {
                (state.activityInfo && state.activityInfo.endTime && state.activityInfo.endTime !== -1 && !state.activityInfo.errorMsg) && <LzTag.Success>执行成功</LzTag.Success>
              }
              {
                ((state.activityInfo && state.activityInfo.startTime && state.activityInfo.endTime === -1 && !state.activityInfo.errorMsg)) && <LzTag.Success>执行中...</LzTag.Success>
              }
              {
                (!state.activityInfo || JSON.stringify(state.activityInfo) === '{}') && <LzTag.Warning>未执行</LzTag.Warning>
              }
              {
                (state.activityInfo && state.activityInfo.errorMsg) && <LzTag.Error>执行失败 {state.activityInfo.errorMsg}</LzTag.Error>
              }
            </div>
          </Form.Item>
        </Form>
      }
      <LzDialog footer={false} shouldUpdatePosition title="保存人群包" visible={isSelectCrow}
        onCancel={() => setSelectCrow(false)}
        onClose={() => setSelectCrow(false)}>
          <SaveCrowd saveCrowdData={saveCrowdData} confirm={(crowdInfo) => confirm(crowdInfo)} cancel={cancel}/>
      </LzDialog>
    </div>
  )
}
